import * as actions from 'redux/actions/account.actions'

import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'

import { getAccountDataFailure, getAccountDataSuccess } from 'redux/actions/account.actions'
import { setUsage } from 'redux/actions/appUsage.actions'

function* getAccountDataSaga() {
  try {
    const body = yield call(agent.Auth.account)
    yield put(getAccountDataSuccess(body))
    yield put(setUsage(body))
  } catch (error) {
    yield put(getAccountDataFailure(error))
  }
}

export default function* accountSagas() {
  yield all([takeLatest(actions.getAccountData.type, getAccountDataSaga)])
}
